import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Preview.css";

const Preview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state; // ✅ Dashboard nundi data vachindi

  if (!data) {
    return (
      <div className="preview-container">
        <h2>No Data Found 😕</h2>
        <button onClick={() => navigate("/dashboard")} className="back-btn">
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="preview-container">
      <div className="profile-card">
        <h1>{data.name}</h1>
        <h3>{data.title}</h3>
        <p>{data.about}</p>

        <div className="section">
          <h2>Skills</h2>
          <ul>
            {data.skills.split(",").map((skill, i) => (
              <li key={i}>{skill.trim()}</li>
            ))}
          </ul>
        </div>

        <div className="section">
          <h2>Projects</h2>
          <ul>
            {data.projects.split(",").map((project, i) => (
              <li key={i}>{project.trim()}</li>
            ))}
          </ul>
        </div>

        <div className="section links">
          <h2>Connect</h2>
          {data.linkedin && (
            <a href={data.linkedin} target="_blank" rel="noreferrer">
              LinkedIn
            </a>
          )}
          {data.github && (
            <a href={data.github} target="_blank" rel="noreferrer">
              GitHub
            </a>
          )}
          {data.twitter && (
            <a href={data.twitter} target="_blank" rel="noreferrer">
              Twitter
            </a>
          )}
        </div>

        <button className="publish-btn">🚀 Publish Portfolio</button>
      </div>
    </div>
  );
};

export default Preview;
